<template>
  <div class="foot">
    <div class="foot-top">
      <div class="foot-top-left">
        <div class="text">我们很乐意与您交谈!</div>
        <div class="text2">
          您如果想与我们合作,只需点击按钮旁边的链接直接联系我们。
        </div>
      </div>
      <div class="foot-top-right" @click="tarAbout">联系我们</div>
    </div>
    <div class="foot-line"></div>
    <div class="foot-content">
      <div class="foot-content-left">
        <img class="logo" :src="logo" />
        <div class="text">为医院提供智慧病案协作平台,并利用数据</div>
        <div class="text">来支持各种需求</div>
        <div class="icon">
          <div class="icon-box">
            <img :src="icon_weixin" />
          </div>
          <div class="icon-box">
            <img :src="icon_qq" />
          </div>
          <div class="icon-box">
            <img :src="icon_email" />
          </div>
        </div>
      </div>
      <div class="foot-content-center1">
        <div class="title">链接</div>
        <div class="text" @click="tarHome">首页</div>
        <div class="text" @click="tarProduct">产品中心</div>
        <div class="text" @click="tarSolution">解决方案</div>
        <div class="text" @click="tarSupport">服务支持</div>
        <div class="text" @click="tarAbout">关于我们</div>
      </div>
      <div class="foot-content-right">
        <div class="title">联系我们</div>
        <div class="text">电话：13684985188</div>
        <div class="text">邮箱：269068079@qq.com</div>
        <div class="text">
          <img :src="code" />
        </div>
      </div>
      <div class="foot-content-center2">
        <div class="title">关于</div>
        <div class="text">合作伙伴</div>
        <div class="text">加入我们</div>
      </div>
      <div class="foot-content-right">
        <div class="title">我们的办公室</div>
        <div class="text">深圳市龙岗区平湖街道禾花社区</div>
        <div class="text">富安大道152号海源创新中心721D3</div>
      </div>
    </div>
    <div class="foot-line"></div>
    <div class="foot-bottom">
      版权所有 © 普康软件（深圳）有限公司 |
      <a href="https://beian.miit.gov.cn" target="_blank"
        >粤ICP备2024285470号-1</a
      >
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img/logo2.png";
import icon_qq from "@/assets/img/icon_qq.png";
import icon_weixin from "@/assets/img/icon_weixin.png";
import icon_email from "@/assets/img/icon_email.png";
import code from "@/assets/img/code.png";
export default {
  name: "footPage",
  data() {
    return {
      logo,
      icon_qq,
      icon_weixin,
      icon_email,
      code
    };
  },
  methods: {
    tarHome() {
      this.$router.push("/");
    },
    tarProduct() {
      this.$router.push("/productCenter");
    },
    tarSolution() {
      this.$router.push("/solution");
    },
    tarSupport() {
      this.$router.push("/serviceSupport");
    },
    tarAbout() {
      this.$router.push("/aboutUs");
    },
    tarContact() {
      this.$router.push("/contactUs");
    },
  },
};
</script>

<style lang="scss" scoped>
.foot {
  background-color: #fdfdfd;
  padding: 98px 0 0 0;
  &-top {
    display: flex;
    justify-content: space-between;
    padding: 0 260px 85px 260px;
    &-left {
      margin-top: 10px;
      .text {
        font-size: 32px;
        color: #323232;
      }
      .text2 {
        margin-top: 40px;
        font-size: 16px;
        color: #646464;
      }
    }
    &-right {
      width: 225px;
      height: 60px;
      background-color: #004f6a;
      color: #fff;
      font-size: 16px;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      img{
        width: 100px;
        height: 100px;
      }
    }
  }
  &-line {
    height: 1px;
    width: 100%;
    background-color: #d8d8d8;
  }
  &-content {
    padding: 38px 260px 52px 260px;
    display: flex;
    &-left {
      .logo {
        width: 172px;
        height: 30px;
        margin-bottom: 24px;
      }
      .text {
        font-size: 16px;
        color: #646464;
        margin-top: 10px;
      }
      .icon {
        margin-top: 60px;
        display: flex;
        &-box {
          background-color: #646464;
          border-radius: 50%;
          width: 42px;
          height: 42px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 32px;
          cursor: pointer;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    &-center1,
    &-center2,
    &-right {
      margin-left: 125px;
      .title {
        font-size: 16px;
        color: #333;
      }
      .text {
        margin-top: 24px;
        font-size: 15px;
        color: #646464;
        cursor: pointer;
      }
    }
  }
  &-bottom {
    line-height: 62px;
    color: #646464;
    font-size: 15px;
    text-align: center;
    a {
      color: #646464;
      font-size: 15px;
      text-decoration:none
    }
  }
}
</style>